import * as React from 'react';
import { IBaseProps } from '../../types';
import { ILink } from '../login-page/login-page-links';
import { LogoGoldman } from '../logos/logo-goldman';
import * as styles from './header.css';

interface IHeaderProps extends IBaseProps {
  fillBackground?: boolean;
  push: (url: string) => void;
  links: ILink[];
  disableGsLogoClick: boolean;
}

interface IHeaderState {
  width: number;
  basename: string;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {
  state: IHeaderState = {
    // Use non-null operator here sue to ts 3 doesn't know
    // document.documentElement
    width: document.documentElement?.clientWidth,
    basename: location.protocol + '//' + location.host
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  private handleResize = (): void =>
    this.setState({
      width: document.documentElement?.clientWidth
    });

  private redirectHome = () => this.props.push('/welcome');

  private renderLogo = (): JSX.Element => {
    const { disableGsLogoClick } = this.props;

    const logo = <LogoGoldman className={styles.gsLogo} color="#ffffff" />;

    return (
      <div className={styles.logo} id="login-header-gs-logo">
        {disableGsLogoClick ? (
          logo
        ) : (
          <a href="https://www.goldmansachs.com/" target="_blank" rel="noreferrer">
            {logo}
          </a>
        )}
      </div>
    );
  };

  render() {
    const { links } = this.props;

    return (
      <div className={styles.header} id="login-header">
        <div className={styles.container}>
          {this.renderLogo()}
          <div id="login-header-links">
            <ul>
              {links.map((l, idx) => {
                return (
                  <li key={idx}>
                    <a href={`${this.state.basename}${l.url}`}>{l.title}</a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
